import type { IOther } from 'scenes/Producer/Product/components/InfoDeliveryMethods/Form/Other/types';
import type { TestResult } from 'v2/interfaces/webhook2';

import { apiServiceProxy } from './api-proxy';

class DeliveryProvidersService {
  public async list(newProduct?: boolean) {
    const param = newProduct === true ? 1 : 0;
    const result = await apiServiceProxy.get<IOther[]>(`/deliveryproviders?new=${param}`);
    return result.data;
  }

  public async customTestUrl(url: string) {
    const result = await apiServiceProxy.post<TestResult>('/deliveryproviders/custom/test-url', { url });
    return result.data;
  }

  public async leadloversTestUrl(url: string) {
    const result = await apiServiceProxy.post<TestResult>('/deliveryproviders/leadlovers/test-url', { url });
    return result.data;
  }

  public async apolloTestUrl(url: string) {
    const result = await apiServiceProxy.post<TestResult>('/deliveryproviders/apollo/test-url', { url });
    return result.data;
  }
}

const deliveryProvidersService = new DeliveryProvidersService();

export default deliveryProvidersService;
